import React from "react";
import { Space, Typography } from "antd";
import ModalWithButton from "@src/components/Common/ModalWithButton";

const { Text } = Typography;

/**
 * A JSON schema is edited in a modal, so the row itself has to say whether one is
 * set — otherwise the button looks identical whether the field is empty or not.
 */
export const isSchemaSet = (value: any) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "string") {
        const trimmed = value.trim();
        return trimmed !== "" && trimmed !== "{}";
    }
    return Object.keys(value).length > 0;
};

const SchemaField = ({ value, onSave, disabled = false, label }: {
    value: any,
    onSave: (value: any) => void,
    disabled?: boolean,
    label: string,
}) => (
    <Space size="middle" wrap>
        <ModalWithButton
            handleOk={disabled ? () => {} : onSave}
            editorType={"json"}
            buttonTitle={disabled ? `View ${label}` : `Edit ${label}`}
            initialValue={value ?? ""}
            disabled={disabled}
        />
        <Text type="secondary">{isSchemaSet(value) ? "Configured" : "Not set"}</Text>
    </Space>
);

/**
 * The same field as a form control: it takes its value from the form and hands
 * back text, so a schema can be a plain <Field name=…> like any other input —
 * including the server's errors on it, which a modal of its own could not show.
 */
export const SchemaControl = ({ value, onChange, disabled, label }: {
    value?: any,
    onChange?: (value: string | null) => void,
    disabled?: boolean,
    label: string,
}) => (
    <SchemaField
        label={label}
        disabled={disabled}
        value={value}
        onSave={(next: any) =>
            onChange?.(next == null ? null : typeof next === "string" ? next : JSON.stringify(next, null, 2))
        }
    />
);

export default SchemaField;